import React from "react"
import { Paper, styled } from "@mui/material";
import SectionHeader from "./SectionHeader";
import { Box } from "@mui/system"

const StyledNotes = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body1,
    textAlign: 'left',
    color: theme.palette.text.primary,
    boxShadow: 'none',
    padding: theme.spacing(0, 0, 0, 4)
}));

const Notes = (props) => {
  const { content, title } = props
  
  return (
    <Box>
        <SectionHeader title={title} />
        <StyledNotes>{content}</StyledNotes>
    </Box>
  );
}

export default Notes